module.exports = __webpack_public_path__ + "static/media/layer6.a093e340.png";